export default {
  setLanguagesListState(state, data) {
    state.languagesList = data;
  },
  addLanguageItemState(state, language) {
    state.languagesList.push(language);
  },
  removeLanguageItemState(state, language) {
    let index = state.languagesList.indexOf(language);
    state.languagesList.splice(index, 1);
  }
};
